export default __webpack_public_path__ + "static/media/Vendor_Video.f77f2d8f.mp4";